import { render, staticRenderFns } from "./add-service.vue?vue&type=template&id=db5a7f76&"
import script from "./add-service.js?vue&type=script&lang=js&"
export * from "./add-service.js?vue&type=script&lang=js&"
import style0 from "./add-service.css?vue&type=style&index=0&lang=css&"
import style1 from "./add-service-vuetify.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardTitle})
